import styled from "styled-components";

export const StyledInboxPage = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0%;
  color: ${({ theme }) => theme.colors.text};
  padding: 20px 20px 10px 20px;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .vertical-display {
    height: calc(100vh - 180px);
    overflow-y: auto;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 40px;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      padding: 40px 30%;
    }
  }
  .inbox-card {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.card};
    padding: 10px;
    box-sizing: border-box;
    border-radius: 8px;
    &:hover {
      box-shadow: ${({ theme }) =>
        theme.colors.card === theme.card
          ? theme.boxShadows.dark
          : theme.boxShadows.light};
    }
    h4 {
      font-size: 16px;
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      margin: 0px;
    }
    span {
      font-size: 12px;
    }
    .unit-img {
      border-radius: 5px;
      min-width: 50px;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      width: 100%;
    }
  }
  .inbox-inner-card {
    width: 80%;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      width: 90%;
    }
  }
`;

export const StyledReply = styled.div`
  color: #5f7efb;
  cursor: pointer;
  font-weight: 600;
  font-size: 12px;
`;
